// App.js
import React from 'react';
import styled from 'styled-components'; 

const Row = styled.div` 
    display: flex; 
    /* Add any other styles you want */ `;
    
const RowV = ({ children }) => {
    return (
        <Row>
            {children}
        </Row>
    );
};

export default RowV;
